module.exports = __webpack_public_path__ + "static/media/spinning_static.fb05c86d.png";